<template>
    <div class="container mescroll-touch">
        <div class="topdh" @click="back"><img src="../../assets/images/bjback.png" class="homeimg" />首页&nbsp;>&nbsp;会议日程
        </div>
        <div class="total">
            <img src="../../assets/images/bjtitle2.png" class="img" />
            <div class="rclist">
                <div class="datelist" v-for="(item, index) in searchdate" :key="index">
                    <div class="titletime">{{ item.DateStr }}</div>
                    <div class="innerlist" v-for="(iitem, index) in item.DateZH" :key="index"
                        @click="tomeeting(iitem.Id)">
                        <div class="dateleft">
                            <div class="lefttitle">{{ iitem.Theme }}</div>
                            <div class="tarow">
                                <div class="lefttime">{{ iitem.DateTimeStr }}</div>
                                <div class="leftadd">{{ iitem.Address }}</div>
                            </div>
                        </div>
                        <div class="dataright">
                            <img src="../../assets/images/dtrow.png" alt="" class="dtjt">
                        </div>
                    </div>
                </div>
            </div>
            <img src="../../assets/images/bjfooter.png" class="footerimg" />
        </div>
    </div>
</template>

<script>
import mixin from '../../common/mixin/mixins'
export default {
    name: 'bjwelcome',
    data() {
        return {
            imgurl: '',
            searchdate: [],
            datemeetinglist: [],
        }
    },
    mixins: [mixin],
    created() {
        this.initbjShare();
        this.getdate();
        document.title = "第九届北京肿瘤防治研究会年会暨第十九届绿荫沙龙学术年会";
    },
    methods: {
        getdate() {
            let that = this;
            this.$axios.post(' /api/api/web/activity/GetScheduleDateNew', {
                ActivityCode: "BJZLNH9",
            }).then(res => {
                that.searchdate = res.Data
                for (var i = 0; i < that.searchdate.length; i++) {
                    // console.log(i)
                    let x = i
                    that.$axios.post(' /api/api/web/activity/GetSchedule', {
                        ActivityCode: "BJZLNH9",
                        Date: that.searchdate[i].DateStr
                    }).then(res => {
                        // console.log('i', x)
                        that.datemeetinglist = res.Data
                        // that.searchdate[i].innerlist = res.Data
                        // console.log('1',that.datemeetinglist)
                        that.searchdate[x].DateZH = that.datemeetinglist
                    })
                }
                // console.log(that.searchdate)
                for (var j = 0; j < that.searchdate.length; j++) {
                    let time = that.searchdate[j].DateStr.replace(/(\d{4})-(\d{1,2})-(\d{1,2})/, '$1年$2月$3日');
                    that.searchdate[j].DateStr = time
                }
                // console.log(that.searchdate)
            })
        },
        back() {
            this.$router.replace({ name: 'BJZL' })
        },
        tomeeting(id) {
            this.$router.push({
                path: 'bjmeeting',
                query: {
                    Id: id,
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
body {
    -webkit-overflow-scrolling: unset
}

.container {
    // height: 100%;
    width: 100%;
    position: relative;
    -webkit-overflow-scrolling: unset // background: rgb(228, 236, 255);
}

.total {
    position: relative;
    height: 100%;
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.guanggaoimg {
    display: block;
    width: 90%;
    margin: 0.5rem auto;
}

.footerimg {
    display: block;
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 1;
}

.topdh {
    font-family: cursive;
    font-weight: bold;
    background-image: linear-gradient(to right, #01B671, #2D5EAA);
    color: #fff;
    padding: 0.3rem;
}

.homeimg {
    width: 5%;
    display: inline-block;
    vertical-align: text-bottom;
    margin-right: 0.1rem;
}

.mainimg {
    width: 100%;
    position: relative;
    z-index: 100;
    margin-bottom: 1.8rem;
}

.titletime {
    text-align: center;
    background-image: linear-gradient(to right, #1DA4BA, #2D5EAB);
    color: #fff;
    font-size: .5rem;
    padding: 0.2rem 0;
}

.innerlist {
    display: flex;
    flex-direction: row;
    padding: 0.4rem 0.5rem;
}

.innerlist:nth-child(odd) {
    background-color: #fff;
}

.innerlist:nth-child(even) {
    background-color: #E9F0F8;
}

.dateleft {
    display: flex;
    flex-direction: column;
    font-weight: bold;
    width: 90%;
    margin-right: 3%;
}

.dataright {
    width: 7%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.tarow {
    display: flex;
    flex-direction: row;
    font-size: .36rem;
    color: #9b9b9b;
    justify-content: start;
    align-items: baseline;
}

.lefttitle {
    margin-bottom: .1rem;
    color: #3866AD;
    font-size: .43rem;
}

.lefttime {
    margin-right: 3%;
    width: 27%;
}

.leftadd {
    width: 70%;
}

.dtjt {
    display: block;
    width: 90%;
    margin: auto;
}

.rclist {
    margin-bottom: 2rem;
}
</style>